import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { 
  TokenContractAssignment, 
  TokenDetail, 
  UserWallet,
  AddTokensResponse,
  EncashTokensResponse,
  EncashTokensRequest,
  BaseTokenRequest,
  BalanceResponse,
  BlockChainHashesResponse
} from '../../interfaces/responses/models';

@Injectable({
  providedIn: 'root'
})
export class WalletService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  private createCompleteUrl(path: string): string {
    return `${this.apiUrl}${path}`;
  }

  getWallets(searchNames: string[], bidRoundId?: string): Observable<UserWallet[]> {
    let queryParams = searchNames.map(name => `names=${encodeURIComponent(name)}`).join('&');
    if (bidRoundId && bidRoundId.trim() !== '') {
      const cleanBidRoundId = bidRoundId.replace(/['"]/g, '');
      queryParams += `&bid_round_id=${encodeURIComponent(cleanBidRoundId)}`;
    }
    return this.http.get<UserWallet[]>(this.createCompleteUrl(`blockchain/wallets?${queryParams}`));
  }
  
  getTokenContracts(userId: string, bidRoundId?: string): Observable<TokenContractAssignment[]> {
    let url = `blockchain/token-contracts?user_id=${encodeURIComponent(userId)}`;
    if (bidRoundId && bidRoundId.trim() !== '') {
      const cleanBidRoundId = bidRoundId.replace(/['"]/g, '');
      url += `&bid_round_id=${encodeURIComponent(cleanBidRoundId)}`;
    }
    return this.http.get<TokenContractAssignment[]>(this.createCompleteUrl(url));
  }

  getTokenDetails(userId: string, bidRoundId?: string): Observable<TokenDetail[]> {
    let url = `blockchain/token-details?user_id=${encodeURIComponent(userId)}`;
    if (bidRoundId && bidRoundId.trim() !== '') {
      const cleanBidRoundId = bidRoundId.replace(/['"]/g, '');
      url += `&bid_round_id=${encodeURIComponent(cleanBidRoundId)}`;
    }
    return this.http.get<TokenDetail[]>(this.createCompleteUrl(url));
  }

  addTokensToUser(data: BaseTokenRequest): Observable<AddTokensResponse> {
    return this.http.post<AddTokensResponse>(
      this.createCompleteUrl('blockchain/add-tokens-to-user'),
      data
    );
  }

  encashTokens(data: EncashTokensRequest): Observable<EncashTokensResponse> {
    return this.http.post<EncashTokensResponse>(
      this.createCompleteUrl('blockchain/en_cash-tokens'),
      data
    );
  }

  getAvailableBalance(userId: string): Observable<BalanceResponse> {
    return this.http.get<BalanceResponse>(
      this.createCompleteUrl(`blockchain/available-balance?user=${encodeURIComponent(userId)}`)
    );
  }

  getBlockChainHashes(bidRoundId: string): Observable<BlockChainHashesResponse> {
    return this.http.get<BlockChainHashesResponse>(
      this.createCompleteUrl(`blockchain/hashes?bid_round_id=${encodeURIComponent(bidRoundId)}`)
    );
  }
}
